import actions from './actionTypes';

const initialState = {
  productSizes: null,
  sessionData: null,
  storeData: null,
  envData: null,
  startUpScene: null,
  themeResponseList: [],
  themesArray: null,
  scenesData: null,
  elementsData: null,
  photosData: null,

  wallLayouts: [],

  unsplashPlaceholder: null,
  vecteezyPlaceholder: null,
  gettyImagePlaceholder: null,
  gettyImageBackgroundPlaceholder: null,
  gettyImagePhotosPlaceholder: null,
  gettyImageObjectsPlaceholder: null,
  iStockBackgroundPlaceholder: null,
  iStockPhotosPlaceholder: null,
  iStockObjectsPlaceholder: null,
  textFonts: [],
  inspirationFonts: [],
  defaultColors: [],
  progressData: 5,
  projectIsInitiated: false,
  isDropboxHidden: false,
  isInstagramHidden: false,
  isSingleProduct: false
};

export default function modalReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_IS_DROPBOX_HIDDEN:
      return {
        ...state,
        isDropboxHidden: action.payload.isDropboxHidden
      };
    case actions.SET_IS_INSTAGRAM_HIDDEN:
      return {
        ...state,
        isInstagramHidden: action.payload.isInstagramHidden
      };
    case actions.SET_SESSION:
      return {
        ...state,
        sessionData: action.payload.sessionData,
        progressData: state.progressData + 15
      };
    case actions.FETCH_ENV_VARIABLES:
      return {
        ...state,
        envData: action.payload.res.data,
        progressData: state.progressData + 10
      };
    case actions.FETCH_STORE_DETAILS:
      return {
        ...state,
        storeData: action.payload.storeData,
        progressData: state.progressData + 10
      };
    case actions.SET_AVAILABLE_PROJECT_SIZES:
      return {
        ...state,
        productSizes: action.payload.productStack
      };
    case actions.GET_THEMES_ARRAY:
      return {
        ...state,
        themesArray: action.payload.themesArray,
        progressData: state.progressData + 25
      };
    case actions.SET_THEME_RESPONSE:
      return {
        ...state,
        themeResponseList: action.payload.themeResponseList
      };
    case actions.FETCH_THEME_ELEMENTS:
      return {
        ...state,
        scenesData: action.payload.scenesData,
        elementsData: action.payload.elementsData,
        photosData: action.payload.photosData,
        progressData: state.progressData + 20
      };
    case actions.FETCH_DEFAULT_COLORS:
      return {
        ...state,
        defaultColors: action.payload.defaultColors,
        progressData: state.progressData + 5
      };
    case actions.FETCH_FONTS:
      return {
        ...state,
        textFonts: action.payload.textFonts,
        progressData: state.progressData + 5
      };
    case actions.GET_STARTUP_SCENE:
      return {
        ...state,
        startUpScene: action.payload.startUpScene,
        progressData: state.progressData + 5
      };
    case actions.FETCH_WALL_LAYOUTS:
      return {
        ...state,
        wallLayouts: action.payload.wallLayouts
      };
    case actions.SET_VECTEEZY_PLACEHOLDER:
      return {
        ...state,
        vecteezyPlaceholder: action.payload.vecteezyPlaceholder
      };
    case actions.SET_UNSPLASH_PLACEHOLDER:
      return {
        ...state,
        unsplashPlaceholder: action.payload.unsplashPlaceholder
      };
    case actions.SET_GETTY_IMAGE_PLACEHOLDER:
      return {
        ...state,
        gettyImagePlaceholder: action.payload.gettyImagePlaceholder
      };
    case actions.SET_GETTY_IMAGE_BACKGROUND_PLACEHOLDER:
      return {
        ...state,
        gettyImageBackgroundPlaceholder:
          action.payload.gettyImageBackgroundPlaceholder
      };
    case actions.SET_GETTY_IMAGE_PHOTOS_PLACEHOLDER:
      return {
        ...state,
        gettyImagePhotosPlaceholder: action.payload.gettyImagePhotosPlaceholder
      };
    case actions.SET_GETTY_IMAGE_OBJECTS_PLACEHOLDER:
      return {
        ...state,
        gettyImageObjectsPlaceholder:
          action.payload.gettyImageObjectsPlaceholder
      };
    case actions.SET_I_STOCK_BACKGROUND_PLACEHOLDER:
      return {
        ...state,
        iStockBackgroundPlaceholder: action.payload.iStockBackgroundPlaceholder
      };
    case actions.SET_I_STOCK_PHOTOS_PLACEHOLDER:
      return {
        ...state,
        iStockPhotosPlaceholder: action.payload.iStockPhotosPlaceholder
      };
    case actions.SET_I_STOCK_OBJECTS_PLACEHOLDER:
      return {
        ...state,
        iStockObjectsPlaceholder: action.payload.iStockObjectsPlaceholder
      };

    case actions.PATTERN_DESIGN_LOGIN_SUCCESS:
      return {
        ...state,
        envData: {
          ...state.envData,
          has_valid_pattern_design_account: true
        }
      };
    case actions.PATTERN_DESIGN_LOGOUT_SUCCESS:
      return {
        ...state,
        envData: {
          ...state.envData,
          has_valid_pattern_design_account: false
        }
      };
    case actions.VECTEEZY_LOGOUT_SUCCESS:
      return {
        ...state,
        envData: {
          ...state.envData,
          has_valid_vecteezy_account: false
        }
      };
    case actions.SET_PROJECT_INITIATED:
      return {
        ...state,
        projectIsInitiated: action.payload.value
      };
    case actions.SET_INSPIRATION_FONTS:
      return {
        ...state,
        inspirationFonts: action.payload.inspirationFonts
      };
    case actions.UPDATE_WITH_INSPIRATION_FONTS:
      return {
        ...state,
        textFonts: action.payload.textFonts
      };
    case actions.SET_DREAMSTIME_USER_LOGGED_IN:
      return {
        ...state,
        envData: {
          ...state.envData,
          dreamstime_user_logged_in: action.payload.isLoggedIn,
          has_valid_dreamstime_account: action.payload.isLoggedIn
        }
      };
    case actions.SET_ADOBE_STOCK_USER_LOGGED_IN:
      return {
        ...state,
        envData: {
          ...state.envData,
          adobe_stock_user_logged_in: action.payload.isLoggedIn,
          has_valid_adobe_stock_account: action.payload.isLoggedIn
        }
      };
    case actions.UPDATE_THEME_ELEMENTS:
      return {
        ...state,
        scenesData: action.payload.scenesData,
        elementsData: action.payload.elementsData,
        photosData: action.payload.photosData
      };
    case actions.UPDATE_CATEGORY:
      return {
        ...state,
        envData: {
          ...state.envData,
          category: action.payload.value
        }
      };
    case actions.SET_SINGLE_PRODUCT:
      return {
        ...state,
        isSingleProduct: action.payload.value
      };
    case actions.UPDATE_PRODUCT_SIZES:
      return {
        ...state,
        productSizes: action.payload.productSizes
      };
    default:
      return state;
  }
}
